import React, { useState } from 'react'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import { ConnectionItem } from 'components/Connections'
import { Personadd } from '@dsny/dsny-component-library/icons'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from './ConnectionsDropdown.styles'
import { StyledComboboxSearchInput } from 'components/SelectInput/SelectInput.styles'

export const ConnectionsDropdown = ({
  connections = [],
  selectedConnections = [],
  onConnectionSelect,
  error
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [value, setValue] = useState('')
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)

  const openCombobox = () => {
    setOpen(true)
  }

  const closeCombobox = () => {
    setOpen(false)
  }

  const handleChange = (text) => {
    setValue(text)
    setSearch(text)
  }

  const onConnectionClick = (connection) => {
    setValue('')
    setSearch('')
    onConnectionSelect(connection)

    setOpen(false)
  }

  const getResults = (value) => {
    return connections
      .filter((connection) =>
        connection.full_name.toLowerCase().includes(value.toLowerCase())
      )
      .filter(
        (connection) =>
          !selectedConnections.some(
            (selected) => selected.player_id === connection.player_id
          )
      )
  }

  const results = getResults(search)

  return (
    <Tonality.Combobox
      isOpen={open}
      onClick={openCombobox}
      onClose={closeCombobox}
      style={{ flex: '1', height: '44px' }}
      setting="player"
      autoFocus={false}
      allowSearch
      value={value}
    >
      <StyledComboboxSearchInput
        placeholder={`${t('share-release.select-to-share-with')}...`}
        onChange={handleChange}
        value={search}
        icon={<Personadd />}
        hasError={error}
        showArrow
      />

      {error && <ErrorMessage>{error}</ErrorMessage>}

      <Tonality.ComboboxPopover
        style={{
          maxHeight: 202,
          minHeight: 'unset',
          flexDirection: 'column'
        }}
      >
        {results.length > 0 ? (
          results.map((connection) => (
            <ConnectionItem
              key={connection.player_id}
              connection={connection}
              onClick={() => onConnectionClick(connection)}
            />
          ))
        ) : (
          <span
            style={{
              display: 'block',
              margin: 8,
              color: theme.colors.neutralW60
            }}
          >
            {t('search.no-results-found')}
          </span>
        )}
      </Tonality.ComboboxPopover>
    </Tonality.Combobox>
  )
}
